import { settings, saveSettings } from '@/config/settings';

/**
 * Fullscreen is OPT-IN: asked once via the in-game prompt, toggleable in
 * settings. Re-entry only happens on POINTER gestures — never on keydown,
 * so Esc can exit fullscreen / close menus without fighting the game.
 */
export function enterFullscreen(): void {
  if (document.fullscreenElement) return;
  document.documentElement.requestFullscreen().catch(() => {
    /* rejected (no transient activation / iframe) — stay windowed */
  });
}

export function exitFullscreen(): void {
  if (document.fullscreenElement) void document.exitFullscreen();
}

export function setFullscreenPreference(on: boolean): void {
  settings.fullscreen = on;
  settings.fullscreenPrompted = true;
  saveSettings();
  if (on) enterFullscreen();
  else exitFullscreen();
}

/** Pointer-gesture re-entry while the preference is on. */
export function hookFullscreenRetry(): void {
  window.addEventListener('pointerdown', () => {
    if (settings.fullscreen) enterFullscreen();
  });
}
